import React, { useState, useEffect } from "react";
import { Button } from '@themesberg/react-bootstrap';
import { CSVLink } from 'react-csv';
import { useSelector } from "react-redux";
import { validPermission } from '../../utils/functions';
import { FaDownload } from 'react-icons/fa';

function DownloadButton({ infoReport, filename, separator }) {
  const [disabled, setDisabled] = useState(true);
  const permissions = useSelector((state) => state.user.permissions);
  const version = useSelector((state) => state.uiVersion?.version || 'v2');

  useEffect(() => {
    if (infoReport.length > 0) {
      setDisabled(false);
    }
  }, [infoReport]);

  if (!validPermission(permissions, 'download')) return null;

  // Modern V2 Button
  if (version === 'v2') {
    if (disabled) {
      return (
        <button
          type="button"
          disabled={disabled}
          className="v2-btn v2-btn-secondary mb-3 opacity-50"
          title="Descargar reporte CSV"
        >
          <FaDownload className="text-muted" /> Descargar CSV
        </button>
      );
    }
    return (
      <CSVLink data={infoReport} filename={filename} separator={separator} style={{ textDecoration: 'none' }}>
        <button
          type="button"
          className="v2-btn v2-btn-secondary mb-3"
          title="Descargar reporte en formato CSV"
        >
          <FaDownload className="text-danger" /> Descargar CSV
        </button>
      </CSVLink>
    );
  }

  // Classic V1 Button
  if (disabled) {
    return (
      <Button disabled={disabled} variant="primary">
        Descargar Reporte
      </Button>
    );
  }
  return (
    <CSVLink data={infoReport} filename={filename} separator={separator}>
      <Button variant="primary">
        Descargar Reporte
      </Button>
    </CSVLink>
  );
}

export default DownloadButton;
